import { ActionTypes } from "../types";

const initialState: any = [];

export const selectedCharactersReducer = (state = initialState, action) => {
  const id = action.payload?.id;
  let newState;

  switch (action.type) {
    case ActionTypes.SELECT_CHARACTER:
      newState = [...state, id];
      trackSquadSelection(newState);
      return newState;

    case ActionTypes.DESELECT_CHARACTER:
      newState = state.filter((el) => el !== id);
      trackSquadSelection(newState);
      return newState;

    default:
      return state;
  }
};

function trackSquadSelection(squad) {
  (window as any).analytics?.track("Squad Select", {
    squad,
  });
}
